import { mapGetters, mapState } from "vuex";
import localeMixin from "./localeMixin";

export default {
  mixins: [ localeMixin ],

  computed: {
    ...mapGetters({
      // Valves
      buildValves: 'build/valves/getValves',
      allValves: 'valves/getAll',
      allAdditionalValves: 'additionalValves/getAll',

      type: 'preference/getMotorOption',
      tank: 'build/getTank',
      oilCooler: 'build/getOilCooler',
      electricalBox: 'build/getElectricalBox',
      circuit: "build/getCircuit",
    }),
    ...mapState({
      motor: state => state.preference.selectedMotor,
      powerpackOptions: state => state.powerpackOptions.all,
      workplaceOptions: state => state.workplaceOptions.all,
      openFrameOptions: state => state.openFrameOptions.all,
      frameOptions: state => state.frameOptions.all,
      pressure: state => state.preference.pressure,
      valveType: state => state.build.valveType,
      throttle: state => state.build.returnThrottling,
    }),
    //TODO ERROR
    valves() {
      let valves = [];
      this.buildValves.forEach(valve => {
        let v = this.allValves[valve.id];
        v.additionalValves = [];

        valve.additionalValves.forEach(av => {
          v.additionalValves.push(this.allAdditionalValves[av]);
        });

        valves.push(v);
      });

      return valves;
    },
  }
}
